import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgPersonSecurity = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M18.5 12c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5Zm0 8.1a3.588 3.588 0 0 1-2.862-1.427l.297-.823h5.13l.297.823A3.588 3.588 0 0 1 18.5 20.1Zm-.005-6.282c.927 0 1.683.756 1.683 1.683s-.756 1.683-1.683 1.683a1.686 1.686 0 0 1-1.683-1.683c0-.927.756-1.683 1.683-1.683Z"
    />
    <path
      fill="#88827E"
      d="M21 2v7.5h-2V4H5v6c0 4.647 1.84 7.558 6.5 10.112v2.251C7.285 20.194 3 17.175 3 10V2h18Z"
    />
  </svg>
);
export default SvgPersonSecurity;
